import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const RewardTiersRoutes: Routes = [
  {
    path: "reward-tiers",
    loadComponent: () =>
      import("./reward-tiers/reward-tiers.component").then(
        (m) => m.RewardTiersComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./reward-tiers-list/reward-tiers-list.component").then(
            (m) => m.RewardTiersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./reward-tiers-form/reward-tiers-form.component").then(
            (m) => m.RewardTiersFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./reward-tiers-form/reward-tiers-form.component").then(
            (m) => m.RewardTiersFormComponent,
          ),
      },
    ],
  },
];
